module.exports = __webpack_public_path__ + "static/media/overview.82203438.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/overview.png
// module id = 77
// module chunks = 0